import {
  Instance,
  SnapshotIn,
  types
} from "mobx-state-tree";

import { LengthUnits } from "convert-units/definitions/length";
import { VolumeFlowRateUnits } from "convert-units/definitions/volumeFlowRate";
import { isLengthUnit, normalizeUnit } from "../convert";
import SensorBase from "./SensorBase";
import { ISensor } from "./Sensors";

const {
  compose,
  maybeNull,
  frozen,
  literal,
  map,
  model,
  number,
  string,
} = types;


export const Sample = model({
  time: string,
  value: number,
});

export interface ISample_ extends SnapshotIn<typeof Sample> { }

export const StageData = model({
  unit: frozen<LengthUnits>(),
  latest: Sample,
  max: map(Sample),
}).actions((self) => ({
  afterCreate() {
    const unit = normalizeUnit(self.unit);
    if (!isLengthUnit(unit)) {
      throw new Error(`Unhandled unit ${unit}`);
    }
    self.unit = unit;
  }
})).named("StageData");


export interface IStageData_ extends SnapshotIn<typeof StageData> { }

export const DischargeData = model({
  unit: frozen<VolumeFlowRateUnits>(),
  latest: Sample,
  max: map(Sample),
}).named("DischargeData");

export interface IDischargeData_ extends SnapshotIn<typeof DischargeData> { }

export const StreamSensor = compose(
  SensorBase,
  model({
    type: literal("stream"),
    stage: maybeNull(StageData),
    discharge: maybeNull(DischargeData),
  }))
    .views((self) => ({
      get hasDischarge() {
        return self.discharge
      },
      stageFor(period: string) {
        if (!self.stage) {
          return undefined;
        }

        const stage = self.stage;
        const sample = (period === "last") ? stage.latest : stage.max.get(period)
        return sample
      },
      dischargeFor(period: string) {
        if (!self.discharge) {
          return undefined;
        }

        const discharge = self.discharge
        const sample = (period === "last") ? discharge.latest : discharge.max.get(period)

        return sample

      },
    }))
    .named("StreamSensor");

export const isStreamSensor = (sensor: ISensor | undefined): sensor is IStreamSensor => sensor?.type === "stream";
export interface IStreamSensor extends Instance<typeof StreamSensor> { }
export interface StreamSensor_ extends SnapshotIn<typeof StreamSensor> { }
